// extracted by mini-css-extract-plugin
module.exports = {"drawer":"styles_drawer__EvxMm","actionBtn":"styles_actionBtn__nyQbG","unclaimed":"styles_unclaimed__eOQ7d","avatar":"styles_avatar__kYuGg"};